import { jsx } from 'react/jsx-runtime';
import { Icon } from '../../icon/Icon.js';

const OptionIcon = ({
  iconName
}) => {
  const icon = iconName;
  return jsx(Icon, {
    name: icon,
    size: 18
  });
};

export { OptionIcon };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3B0aW9uSWNvbi5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vbGlicy9yZWFjdC1jb21wb25lbnRzL3NyYy9saWIvY29tcG9uZW50cy9mb3JtL2Ryb3Bkb3duLWxpc3QvT3B0aW9uSWNvbi50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgRkMgfSBmcm9tICdyZWFjdCdcbmltcG9ydCB7IEljb24gfSBmcm9tICcuLi8uLi9pY29uJ1xuaW1wb3J0IHsgSWNvbk5hbWUgfSBmcm9tICcuLi8uLi9pY29uL2ljb24tY29tcG9uZW50cy9uYW1lcydcblxuZXhwb3J0IGNvbnN0IE9wdGlvbkljb246IEZDPHsgaWNvbk5hbWU/OiBzdHJpbmcgfT4gPSAoeyBpY29uTmFtZSB9KSA9PiB7XG4gIGNvbnN0IGljb24gPSBpY29uTmFtZSBhcyBJY29uTmFtZVxuICByZXR1cm4gPEljb24gbmFtZT17aWNvbn0gc2l6ZT17MTh9IC8+XG59XG4iXSwibmFtZXMiOlsiT3B0aW9uSWNvbiIsImljb25OYW1lIiwiaWNvbiIsIl9qc3giLCJJY29uIiwibmFtZSIsInNpemUiXSwibWFwcGluZ3MiOiI7OztBQUlPLE1BQU1BLFVBQVUsR0FBOEJBLENBQUM7QUFBRUMsRUFBQUEsUUFBQUE7QUFBVSxDQUFBLEtBQUk7RUFDcEUsTUFBTUMsSUFBSSxHQUFHRCxRQUFvQixDQUFBO0VBQ2pDLE9BQU9FLEdBQUEsQ0FBQ0MsSUFBSSxFQUFBO0FBQUNDLElBQUFBLElBQUksRUFBRUgsSUFBSTtBQUFFSSxJQUFBQSxJQUFJLEVBQUUsRUFBQTtBQUFFLEdBQUEsQ0FBSSxDQUFBO0FBQ3ZDOzs7OyJ9
